<h2 mat-dialog-title>
  {{ 'igo.geo.style.styleModal' | translate }}
</h2>
<div mat-dialog-content>
  <div class="edit-colorpicker">
    <form class="igo-form" [formGroup]="form">
      <div class="color-picker">
        @if (linestringOnly !== true) {
          <span>
            <mat-icon class="stroke-palette-icon">format_color_fill</mat-icon>
            {{ 'igo.geo.style.fill' | translate }}
          </span>
          <igo-color-picker-form-field
            formControlName="fill"
            (colorChange)="setLayerFillColor($event)"
          />
        }

        <span>
          <mat-icon class="stroke-palette-icon">border_color</mat-icon>
          {{ 'igo.geo.style.stroke' | translate }}
        </span>
        <igo-color-picker-form-field
          formControlName="stroke"
          (colorChange)="setLayerStrokeColor($event)"
        />
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions>
  <button matButton="elevated" (click)="cancel()">
    {{ 'igo.geo.style.cancel' | translate }}
  </button>
  <button matButton="elevated" color="primary" (click)="confirm()">OK</button>
</div>
